import { css } from '@landr/styled-system/css';

export const skeletonTitle = css({
    maxWidth: '80%',
});

export const skeletonTags = css({
    maxWidth: '40%',
});

export const wrapperStyles = css({
    display: 'block',
    width: 'full',
    textAlign: 'left',
    marginLeft: { base: 'xs', lg: 'md' },
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: { base: '150px', sm: '220px', md: 'full' },
});

export const name = css({
    display: 'block',
    color: 'text.base',
    fontSize: 'sm',
    fontWeight: 'bold',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    width: 'full',
    maxWidth: 'full',
});

export const playWrapper = css({
    width: 'full',
    '& > button > span': {
        maxWidth: 'calc(100% - {spacing.sm})',
        flexGrow: 1,
    },
});
